<template>
  <div :class="{ 'is-styled': !disableStyles }">
    <table
      :class="`postbox--${responsiveClass}`"
      class="data-table data-table--fixed postbox"
      aria-describedby="postbox table"
    >
      <thead v-if="$slots.postboxTableHead" class="hidden-sm">
        <slot name="postboxTableHead"> </slot>
      </thead>
      <tbody v-if="$slots.postboxTableBody">
        <slot name="postboxTableBody"> </slot>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'
import { useResponsiveClassByElementSize } from '@/utils/utils'
import { useWindowSize } from '@vueuse/core'

const { width } = useWindowSize()

const { disableStyles } = defineProps({
  disableStyles: {
    type: Boolean,
    default: false
  }
})

const responsiveClass = ref('sm')

onBeforeMount(() => {
  globalThis.addEventListener('resize', onResize)
  onResize()
})

function onResize() {
  responsiveClass.value = useResponsiveClassByElementSize(width.value)
}
</script>

<style lang="scss" scoped>
.is-styled :deep() {
  .data-table {
    display: table;
  }
  .data-table td.postbox,
  .postbox {
    &__date {
      width: calc(var(--grid-gutter-width) * 6);
    }
    &__action {
      width: calc(var(--grid-gutter-width) * var(--postbox-action-modifier));
      vertical-align: middle;
      .icon-download {
        &:before {
          width: var(--postbox-icon-download-font-size);
          font-size: var(--postbox-icon-download-font-size);
          line-height: 48px;
        }
      }
      .icon-auge {
        &:before {
          width: var(--postbox-icon-auge-font-size);
          font-size: var(--postbox-icon-auge-font-size);
          line-height: 52px;
        }
      }
      .icon-vorteile {
        &:before {
          width: var(--postbox-icon-auge-font-size);
          font-size: var(--postbox-icon-auge-font-size);
          color: var(--disabled-color-postbox);
          line-height: 52px;
        }
      }
      :hover span {
        color: var(--postbox-icon-color-hover);
      }
      @media (min-width: 600px) {
        width: calc(var(--grid-gutter-width) * 3.4);
      }
    }
    &__empty {
      display: flex;
      color: var(--postbox-is-empty-box-text-color);
      font-size: var(--postbox-font-size);
      span {
        font-size: var(--postbox-font-size);
        align-self: center;
      }
      span[class^='icon-'] {
        color: var(--postbox-is-empty-box-text-color);
        font-size: var(--postbox-info-icon-font-size);
        margin-right: var(--grid-gutter-width);
        align-self: flex-start;
      }
    }
    .secondary {
      font-size: 16px;
    }
    &__row {
      border-bottom: var(--data-list-border);
    }
    &--xs,
    &--sm {
      thead {
        display: none;
      }

      td {
        display: block;
        float: left;
      }
      .postbox {
        &__date {
          padding: var(--postbox-date-p);
        }
        &__birthday {
          width: 100%;
        }
        &__message {
          width: 100%;
          padding: var(--postbox-message-p);
          &--has-actions {
            width: calc(
              100% - calc(var(--grid-gutter-width) * var(--postbox-action-modifier))
            );
          }
        }
        &__action {
          text-align: center;
          height: var(--postbox-action-height-xs);
          padding-top: 0;
          padding-bottom: 0;
          padding-right: 0;
          line-height: 0;
          & .icon-download {
            &:before {
              line-height: 40px !important;
            }
          }
          .icon-auge {
            &:before {
              line-height: var(--postbox-icon-auge-line-height-mobile) !important;
            }
          }
          > .td-action {
            display: block;
          }
        }
      }
    }
    .td-action,
    .td-action > .td-action {
      font-size: 18px;
      color: var(--postbox-icon-color);
    }
    .td-action > .td-action {
      margin: 0 auto;
      display: inline;
    }
  }
}
</style>
